import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2","key":"svg-0"}],["path",{"d":"M4 8m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z","key":"svg-1"}],["path",{"d":"M10 14h4","key":"svg-2"}],["path",{"d":"M12 12v4","key":"svg-3"}]]

const IconFirstAidKit = createReactComponent('outline', 'first-aid-kit', 'FirstAidKit', __iconNode);

export default IconFirstAidKit;